export const CKEDITORCONFIG: any = {
    toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		'/',
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'colors', groups: [ 'colors' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
    removeButtons: "Save",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "450px"
}

export const CKEDITOR_A4_CONFIG: any = {
    toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		'/',
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'colors', groups: [ 'colors' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
    removeButtons: "Save",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "1123px",
	width: "794px"
}

export const CKEDITOREMAILCONFIG: any = {
    toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		'/',
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'colors', groups: [ 'colors' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
    removeButtons: "Save",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "50vh"
}

export const CKEDITORBOOKINGEMAILCONFIG: any = {
    toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		'/',
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'colors', groups: [ 'colors' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
    removeButtons: "Save",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "45vh",
	width: "100%"
}
export const CKEDITORCONFIGDEV: any = {
    toolbarGroups: [
		{ name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
		{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
		{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
		{ name: 'forms', groups: [ 'forms' ] },
		{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
		{ name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
		{ name: 'links', groups: [ 'links' ] },
		{ name: 'insert', groups: [ 'insert' ] },
		'/',
		{ name: 'styles', groups: [ 'styles' ] },
		{ name: 'colors', groups: [ 'colors' ] },
		{ name: 'tools', groups: [ 'tools' ] },
		{ name: 'others', groups: [ 'others' ] },
		{ name: 'about', groups: [ 'about' ] }
	],
    removeButtons: "Save,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,Table,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "450px"
}

export const CKEDITORCONFIGMINIMAL: any = {
    toolbarGroups: [
		{ name: 'paragraph', groups: [ 'list' ] },
		{ name: 'colors', groups: [ 'colors' ] }
  ], 
  removeButtons: "Save,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,PageBreak,SpecialChar,HorizontalRule,BGColor",
  contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
  defaultLabel: "Arial",
  height: "150px",
  width: "300px",
  protectedSource: []
};

export const CKEDITORCONFIGMINIMALWITHLINK: any = {
  toolbar: [
	{ name: 'basicstyles', items: [ 'Bold', 'Italic' ]},
	{ name: 'colors', items: [ 'TextColor' ] },
	{ name: 'paragraph', items: [ 'BulletedList' ] },
	{ name: 'links', items: [ 'Link', 'Unlink' ] },
  ],
  removeButtons: "Save,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,PageBreak,SpecialChar,HorizontalRule,BGColor",
  contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
  defaultLabel: "Arial",
  height: "150px",
  width: "100%",
  protectedSource: []
};

export const CKEDITORCONFIG_BOOKING_CONFIRMATION: any = {
	toolbar: [
	  { name: 'basicstyles', items: [ 'Bold', 'Italic' ]},
	  { name: 'colors', items: [ 'TextColor' ] },
	  { name: 'paragraph', items: [ 'BulletedList' ] },
	  { name: 'links', items: [ 'Link', 'Unlink' ] },
	],
	removeButtons: "Save,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,PageBreak,SpecialChar,HorizontalRule,BGColor",
	contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
	defaultLabel: "Arial",
	height: "150px",
	width: "calc(100% - 8px)",
	protectedSource: []
  };
